export const TAG_CRUD_FORM_LOADING = {
    tagCreateEditDelete: {
        status: "LOADING",
        meta: {
            title: 'edit tag',
            button: 'save',
            type: 'edit'
        },
        payload: null
    }
};
export const TAG_CRUD_FORM_CANCEL = () => ({
    tagCreateEditDelete: {
        status: "",
        meta: {
            title: '',
            button: '',
            type: ''
        },
        payload: null
    }
});
export const TAG_CRUD_FORM_CREATE = () => ({
    tagCreateEditDelete: {
        status: "DONE",
        meta: {
            title: 'create tag',
            button: 'save',
            type: 'create'
        },
        payload: null
    }
});
export const TAG_CRUD_FORM_DONE = (payload) => ({
    tagCreateEditDelete: {
        status: "DONE",
        meta: {
            title: 'edit tag',
            button: 'save',
            type: 'save'
        },
        payload: payload
    }
});
export const TAG_CRUD_FORM_DELETE = (payload) => ({
    tagCreateEditDelete: {
        status: "DONE",
        meta: {
            title: 'delete tag',
            button: 'delete',
            type: 'delete'
        },
        payload: payload
    }
});
export const TAG_CRUD_FORM_ERROR = (payload) => ({
    tagCreateEditDelete: {
        status: "ERROR",
        meta: {
            title: 'edit tag',
            button: 'save',
            type: 'error'
        },
        payload: payload
    }
});
export const SET_SELECTED_TAGS = (payload) => ({
    selectedTags: payload
});
export const UPDATE_TAG_STATUS = (payload) => ({
    tags: payload
});
export const TAG_CRUD_FORM_SAVE = (payload) => {
    
};
export const UPDATE_TAGS_STATUS = (payload) => ({
    tags: payload
});